import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home";
import Restaurant from "@/views/Restaurant";
import User from "@/views/User";
import Login from "@/views/Login";
import Signup from "@/views/Signup";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/restaurant",
      name: "Restaurant",
      component: Restaurant,
      props: true
    },
    {
      path: "/user",
      name: "User",
      component: User
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/signup",
      name: "Signup",
      component: Signup
    }
    //todo 404
  ]
});
